import { render, staticRenderFns } from "./px-sticky-bar.vue?vue&type=template&id=1a654ca9&scoped=true&"
import script from "./px-sticky-bar.vue?vue&type=script&lang=ts&"
export * from "./px-sticky-bar.vue?vue&type=script&lang=ts&"
import style0 from "./px-sticky-bar.vue?vue&type=style&index=0&id=1a654ca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a654ca9",
  null
  
)

export default component.exports